import * as React from 'react'
import Documents from './documents'

export default function TabDocuments({ vehicleType }) {
  return <Documents vehicleType={vehicleType} />
}
